import EmailPreviewCompact from "./EmailPreviewCompact/index";
export default EmailPreviewCompact;
